import React from 'react';

const HeroSection = ({ settings }) => {
    if (!settings) {
        return <div className="h-screen bg-background"></div>;
    }

    const content = {
        heroTitle: settings.heroTitle || 'A ARTE DO ESTILO MASCULINO',
        heroSubtitle: settings.heroSubtitle || 'Onde a tradição encontra a precisão.',
        heroImageUrl: settings.heroImageUrl || '',
        heroImageAlt: settings.heroImageAlt || '',
        schedulingLink: settings.schedulingLink || '#',
        heroImagePosition: settings.heroImagePosition || 'center'
    };

    const heroStyle = {
        backgroundImage: `url(${content.heroImageUrl})`,
        backgroundPosition: `center ${content.heroImagePosition || 'center'}`
    };

    return (
        <section 
            id="home" 
            className="relative h-screen flex items-center justify-center text-center bg-cover bg-fixed" 
            style={heroStyle}
            role="img" 
            aria-label={content.heroImageAlt || content.heroTitle} 
        >
            <div className="absolute inset-0 bg-black/60"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-background to-transparent"></div>
            <div className="relative z-10 px-6">
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-4 text-white text-shadow-md">{content.heroTitle}</h1>
                <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto mb-8">{content.heroSubtitle}</p>
                <a href={content.schedulingLink || '#'} target="_blank" rel="noopener noreferrer" className="bg-button text-button-text font-bold py-3 px-8 rounded-lg text-lg hover:opacity-90 transition-opacity transform hover:scale-105">
                    AGENDAR HORÁRIO
                </a>
            </div>
        </section>
    );
};

export default HeroSection;
